export default (editor, config = {}) => {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;

  const defaultUrls = config.state.paramsClient.display_default_urls;
  const URL =
    defaultUrls && defaultUrls.facebook !== ''
      ? defaultUrls.facebook
      : 'https://www.facebook.com/facebook';

  domc.addType('facebook_widget', {
    model: defaultModel.extend(
      {
        defaults: Object.assign({}, defaultModel.prototype.defaults, {
          'custom-name': 'facebook',
          tagName: 'div',
          src: URL,
          width: '500',
          height: '600',
          traits: [
            {
              type: 'text',
              label: 'src',
              name: 'src',
              changeProp: 1,
            },
          ],
          script: function() {
            setTimeout(() => {
              const id = this.id;
              const element = document.querySelector('#' + id);
              const fbWrapper = element.querySelector('.iframe-facebook-wrapper');
              const fbIframe = element.querySelector('iframe');

              const elWidth = element.clientWidth;
              const elHeight = element.clientHeight;

              const fbWidth = Math.min(elWidth, 500);
              let fbHeight = elHeight;
              let scale = 1;
              let src = fbIframe.src;

              if (elWidth > 500) {
                scale = elWidth / 500;
                fbHeight = elHeight / scale;
              }

              fbWrapper.style.transform = 'scale(' + scale + ')';
              fbWrapper.style['transform-origin'] = '0 0';
              fbWrapper.style.width = fbWidth + 'px';
              fbWrapper.style.height = fbHeight + 'px';

              src = src.replace(/width=\d+/, 'width=' + Math.floor(fbWidth));
              src = src.replace(/height=\d+/, 'height=' + Math.floor(fbHeight));
              fbIframe.src = src;
            }, 100);
          },
        }),
        init() {
          this.listenTo(this, 'change:src', this.updateSrc);
          setTimeout(() => {
            this.view.updateScript();
          }, 1000);
        },
        toHTML() {
          return this.view && this.view.el.getAttribute('data-gjs-type') == 'facebook_widget'
            ? this.view.el.outerHTML
            : '';
        },
        updateSrc() {
          this.view.getIframe().src = this.createUri();
          this.view.updateScript();
        },

        createUri() {
          return (
            'https://www.facebook.com/plugins/page.php?href=' +
            this.get('src') +
            '&tabs=timeline&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&width=500&height=600'
          );
        },
      },
      {
        isComponent(el) {
          var result = '';
          if (el.tagName == 'div') {
            result = { type: 'facebook_widget' };
          }
          return result;
        },
      },
    ),
    view: defaultView.extend({
      initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
      },
      getIframe() {
        if (!this.iframe) {
          var ifrm = document.createElement('iframe');

          // if (this.model.get('src') !== URL) {
          ifrm.src = this.model.createUri();
          // } else {
          //   ifrm.src =
          //     'https://www.facebook.com/plugins/page.php?href=' +
          //     URL +
          //     '&tabs=timeline&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&width=500&height=600';
          // }

          ifrm.className = this.ppfx + 'no-pointer';
          ifrm.width = '100%';
          ifrm.height = '100%';
          ifrm.frameBorder = '0';
          ifrm.style.border = 'none;';
          ifrm.style.overflow = 'scroll';
          ifrm.scrolling = 'no';
          ifrm.frameborder = '0';
          ifrm.allowtransparency = 'true';
          ifrm.allow = 'encrypted-media';

          this.iframe = ifrm;
        }
        return this.iframe;
      },

      render(...args) {
        defaultView.prototype.render.apply(this, args);
        this.updateClasses();
        if (this.el.getElementsByTagName('IFRAME').length == 0) {
          let div = document.createElement('div');
          div.classList.add('iframe-facebook-wrapper');
          div.style.width = '100%';
          div.appendChild(this.getIframe());
          this.el.appendChild(div);
        }
        return this;
      },
    }),
  });
};



// WEBPACK FOOTER //
// ./src/plugins/facebook/components.js